import { AppState } from '@/store/state';
import { ToggleSidebarMenu } from '@/store/ui/actions';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  @HostBinding('class') class = 'wrapper';
  public ui: Observable<UiState>;

  constructor(
    private renderer: Renderer2,
    private store: Store<AppState>,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // 🔒 Validación inmediata
    const token = this.authService.getAuthToken();
    if (!token || this.authService.isTokenExpired(token)) {
      this.authService.logout();
      return;
    }

    this.ui = this.store.select('ui');

    const root = document.querySelector('app-root');

    this.renderer.removeClass(root, 'login-page');
    this.renderer.removeClass(root, 'register-page');
    this.renderer.addClass(root, 'layout-fixed');

    this.ui.subscribe(({ menuSidebarCollapsed, controlSidebarCollapsed, darkMode }) => {
      darkMode=true;
      if (menuSidebarCollapsed) {
        this.renderer.removeClass(root, 'sidebar-open');
        this.renderer.addClass(root, 'sidebar-collapse');
      } else {
        this.renderer.removeClass(root, 'sidebar-collapse');
        this.renderer.addClass(root, 'sidebar-open');
      }

      if (controlSidebarCollapsed) {
        this.renderer.removeClass(root, 'control-sidebar-slide-open');
      } else {
        this.renderer.addClass(root, 'control-sidebar-slide-open');
      }

      if (darkMode) {
        this.renderer.addClass(root, 'dark-mode');
      } else {
        this.renderer.removeClass(root, 'dark-mode');
      }
    });
  }

  onToggleMenuSidebar() {
    this.store.dispatch(new ToggleSidebarMenu());
  }
}
